var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeposited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65289 0.5H18.3471C19.26 0.5 20 1.30394 20 2.29564V8.58057H18.182V6.7849H1.81836V13.0693H10V14.8651H1.65289C0.740025 14.8651 0 14.0612 0 13.0695V2.29564C0 1.30394 0.740025 0.5 1.65289 0.5ZM18.182 2.29541V4.98926H1.81836V2.29541H18.182ZM19.4688 13.0695H15.2999L16.4752 14.2303L15.1896 15.5L11.8195 12.1717L15.1896 8.84335L16.4752 10.1131L15.2999 11.2739H19.4688V13.0695Z",
    fill: "#9295A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposited);
export default __webpack_public_path__ + "static/media/deposited.868aa422fc7f7bf112877cef9345ca7f.svg";
export { ForwardRef as ReactComponent };